import { EvaluationMilestoneEdit } from 'src/screens/shared/project/details/effectivity-management/evaluation-milestone/edit/EvaluationMilestoneEdit'

export const PfPgvEvaluationMilestoneEditPage = () => {
  return <EvaluationMilestoneEdit baseUrl="/pf-pgv" />
}
